/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const PageOrderIdStyled = styled.div.attrs({
    className: 'order',
})`
    /* Common styles */

    .order__content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 32px;
    }

    .order__block:not(:last-child) {
        margin-bottom: 16px;
    }

    .order__block-label {
        margin-bottom: 4px;

        &.order__block-label_light {
            color: ${colors.textColorOpacity};
        }

        &.order__block-label_bold {
            ${fonts.textMainBold};
        }
    }

    .order__sub-title {
        margin-bottom: 16px;
    }

    /* ------------ */

    .order__export {
        width: 290px;

        .select__select-drop-button {
            background-color: ${colors.backgroundColorHoverOpacity};
        }
    }

    .order__parameters,
    .order-subscriber-list {
        grid-column: 1 / 3;
    }

    .order__files-error {
        max-width: 500px;
    }
`;
